import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AmIconModule } from '../am-icon/am-icon.module';
import { LayoutMainDirective } from './layout-center.directive';
import { LayoutElementDirective } from './layout-element.directive';
import { LayoutFooterDirective } from './layout-footer.directive';
import { LayoutHeaderDirective } from './layout-header.directive';
import { LayoutLeftDirective } from './layout-left.directive';
import { LayoutRightDirective } from './layout-right.directive';
import { LayoutRowsComponent } from './layout-rows/layout-rows.component';
import { LayoutContainerDirective } from './layout-container.directive';
import { LayoutAppComponent } from './layout-app/layout-app.component';
import { LayoutColsComponent } from './layout-cols/layout-cols.component';
import { LayoutResponsiveComponent } from './layout-responsive/layout-responsive.component';

@NgModule({
  declarations: [
    LayoutRowsComponent,
    LayoutContainerDirective,
    LayoutAppComponent,
    LayoutColsComponent,
    LayoutElementDirective,
    LayoutLeftDirective,
    LayoutRightDirective,
    LayoutMainDirective,
    LayoutHeaderDirective,
    LayoutFooterDirective,
    LayoutResponsiveComponent,
  ],
  imports: [
    CommonModule,
    AmIconModule,
    MatButtonModule,
    FlexLayoutModule,
    MatDialogModule,
  ],
  exports: [
    LayoutRowsComponent,
    LayoutContainerDirective,
    LayoutAppComponent,
    LayoutColsComponent,
    LayoutElementDirective,
    LayoutLeftDirective,
    LayoutRightDirective,
    LayoutMainDirective,
    LayoutHeaderDirective,
    LayoutFooterDirective,
    LayoutResponsiveComponent,
  ],
})
export class AmLayoutModule {}
